/* CardFooter.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1xC2CJtr1Z%7Bgrid-area%3Afooter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Y7lL45zaO%7Bpadding-inline%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mT5xdRAKS%7Bposition%3Arelative%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._42Yu6Bbhqd%7Bz-index%3A200%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1pp6NdIZbP%7Bpointer-events%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ouGXIdnbC%7Bmin-width%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1wydGW5zaO%7Bpadding-bottom%3Avar(--ds-space-200%2C1pc)%7D");
import React from 'react';
import { Box } from '@atlaskit/primitives/compiled/box';
const styles = {
  footer: "_1xC2CJtr1Z _2Y7lL45zaO _1mT5xdRAKS _42Yu6Bbhqd _1pp6NdIZbP _4ouGXIdnbC _1wydGW5zaO"
};
export type CardFooterProps = {
  children: React.ReactNode;
  testId?: string;
};
export const CardFooter = ({
  children,
  testId
}: CardFooterProps): React.JSX.Element => <Box xcss={styles.footer} testId={testId}>
		{children}
	</Box>;